import React, { useEffect, useState } from "react";
import { Plus, Search, Upload } from "lucide-react";
import { AnimatePresence,motion  } from "framer-motion";

import DocumentCard from "../components/document/DocumentCard";
import DocumentForm from "../components/document/DocumentForm";
import DocumentFilters from "../components/document/DocumentFilter";

import api from "../api/api";

import "../css/document/documentpage.css";

export default function Documents() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showForm, setShowForm] = useState(false);
  const [editingDocument, setEditingDocument] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    document_type: "all",
    status: "all",
  });

  const [saving, setSaving] = useState(false);

  /* ---------------- FETCH DOCUMENTS ---------------- */


 const fetchDocuments = async () => {
  setLoading(true);
  try {
    const res = await api.get("/documents");

    //  ALWAYS extract array safely
    setDocuments(Array.isArray(res.data?.data) ? res.data.data : []);
  } catch (err) {
    console.error("Failed to fetch documents", err);
    setDocuments([]);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchDocuments();
  }, []);

// 30-01-2026

const handleSubmit = async (formData, setUploadProgress) => {
  setSaving(true);
  try {
    if (editingDocument) {
      await api.put(`/documents/${editingDocument._id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      });
    } else {
      await api.post("/documents", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      });
    }

    setShowForm(false);
    setEditingDocument(null);
    fetchDocuments();
  } catch (err) {
    console.error("Failed to save document", err);

    const message =
      err.response?.data?.message || "Failed to save document";

    //  TOKEN MONEY NOT RECEIVED ERROR
    if (message.toLowerCase().includes("token")) {
      alert(
        " Token money has not been received for this deal.\nYou cannot upload documents for this deal."
      );
    } else {
      alert(` ${message}`);
    }
  } finally {
    setSaving(false);
  }
};


  /* ---------------- FILTERING ---------------- */
  const filteredDocuments = Array.isArray(documents)
  ? documents.filter((doc) => {
      const matchesSearch =
        doc.document_name?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesType =
        filters.document_type === "all" ||
        doc.document_type === filters.document_type;

      const matchesStatus =
        filters.status === "all" || doc.status === filters.status;

      return matchesSearch && matchesType && matchesStatus;
    })
  : [];


  return (
    <div className="documents-page">
      <div className="documents-container">
        {/* Header */}
        <div className="documents-header">
          <div>
            <h1>Document Management</h1>
            <p>Organize KYC, agreements, and property documents</p>
          </div>

          <button
            className="primary-btn"
            onClick={() => {
              setEditingDocument(null);
              setShowForm(true);
            }}
          >
            <Upload size={16} />
            Upload Document
          </button>
        </div>

        {/* Search + Filters */}
        <div className="documents-toolbar">
          <div className="search-box">
            <Search size={16} />
            <input
              type="text"
              placeholder="Search documents..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <DocumentFilters filters={filters} setFilters={setFilters} />
        </div>

        {/* Form */}
    

<AnimatePresence>
  {showForm && (
    <motion.div
      className="document-modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => {
        setShowForm(false);
        setEditingDocument(null);
      }}
    >
      <motion.div
        className="document-modal-content"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.2 }}
        onClick={(e) => e.stopPropagation()} //  stop backdrop close
      >
        <DocumentForm
          document={editingDocument}
          onSubmit={handleSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingDocument(null);
          }}
          isLoading={saving}
        />
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>



        {/* Document Grid */}
        <div className="documents-grid">
          {loading ? (
            <div className="loader" />
          ) : filteredDocuments.length === 0 ? (
            <p className="empty-text">No documents found</p>
          ) : (
            filteredDocuments.map((doc, index) => (
              <DocumentCard
                key={doc._id}
                document={doc}
                index={index}
                onEdit={() => {
                  setEditingDocument(doc);
                  setShowForm(true);
                }}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
